import { ReactElement, useState } from 'react';
import classnames from 'classnames';
import Fuse from 'fuse.js';
import { iSponsor } from '@interfaces/interfaces';
import Autosuggest from 'react-autosuggest';
import styles from './TextInputWdpAutosuggest.module.scss';
import theme from './Autosuggest.theme.module.scss';

interface iProps {
  value: string;
  onChange: (newValue: string) => void;
  onSuggestionSelected: (suggestion: string) => void;
  placeholder: string;
  data: iSponsor[];
}

const TextInputWdpAutosuggest = ({ value, onChange, onSuggestionSelected, placeholder, data }: iProps): ReactElement => {
  const [fuse] = useState(
    new Fuse(data, {
      keys: ['OrgName', 'Suburb', 'Postcode'],
      includeScore: true,
      threshold: 0.3,
    })
  );

  const getSuggestions = (inpuValue: string) => {
    if (!inpuValue) return [];

    const results = fuse.search(inpuValue);

    return results.map((result) => `${result.item.OrgName}, ${result.item.Suburb}, ${result.item.Postcode}`);
  };

  const onSuggestionsFetchRequested = ({ value: inputValue }: {value: string}) => {
    onChange(inputValue);
  };

  const onSuggestionsClearRequested = () => {
    onChange('');
  };

  const renderSuggestion = (suggestion: string) => {
    const suggestionString = suggestion;
    return <div>{suggestionString}</div>;
  };

  const getSuggestionValue = (suggestion: string) => {
    const suggestionValue = suggestion;
    return suggestionValue;
  };

  const inputProps = {
    placeholder,
    value,
    onChange: (e: React.FormEvent<HTMLElement>, { newValue }: {newValue: string}) => onChange(newValue),
  };

  return (
    <div
      className={classnames({
        [styles.container]: true,
      })}>
      <div className={styles.autosuggestContainer} tabIndex={-1}>
        <div className={styles.autosuggest}>
          <Autosuggest
            suggestions={getSuggestions(value)}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            onSuggestionSelected={(event, { suggestion }) => onSuggestionSelected(suggestion)}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}
            theme={theme}
          />
        </div>
      </div>
    </div>
  );
};

export default TextInputWdpAutosuggest;
